import { render, staticRenderFns } from "./CensusManagerView.vue?vue&type=template&id=279f9b4f&scoped=true"
import script from "./CensusManagerView.vue?vue&type=script&lang=ts"
export * from "./CensusManagerView.vue?vue&type=script&lang=ts"
import style0 from "./CensusManagerView.vue?vue&type=style&index=0&id=279f9b4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279f9b4f",
  null
  
)

export default component.exports